export const ICS215_COLUMN_LABELS = {
  workGroup: 'Work Group',
  workAssignmentName: 'Work Assignment Name',
  kindsOfResources: 'Kinds of Resources',
  overheadPosition: '8. Overhead Positions',
  specialEquipmentSupplies: '9. Special Equipment & Supplies',
  reportingLocation: '10. Reporting Location',
  requestedArrivalTime: '11. Requested Arrival Time',
  status: 'Status',
  totalRequired: 'Total Resources Required',
  totalOnHand: 'Total Resources On Hand',
  totalNeeded: 'Total Resources Needed',
} as const;

export const ICS215_RHN_ROWS = [
  { field: 'required' as const, label: 'REQ' },
  { field: 'have' as const, label: 'HAVE' },
  { field: 'need' as const, label: 'NEED' },
] as const;

export const ICS215_TOTAL_ROWS = [
  { field: 'required' as const, label: ICS215_COLUMN_LABELS.totalRequired },
  { field: 'have' as const, label: ICS215_COLUMN_LABELS.totalOnHand },
  { field: 'need' as const, label: ICS215_COLUMN_LABELS.totalNeeded },
] as const;

export const ICS215_OVERFLOW_COLUMNS = [
  {
    key: 'overhead_positions' as const,
    label: ICS215_COLUMN_LABELS.overheadPosition,
  },
  {
    key: 'special_instructions' as const,
    label: ICS215_COLUMN_LABELS.specialEquipmentSupplies,
  },
  {
    key: 'reporting_location' as const,
    label: ICS215_COLUMN_LABELS.reportingLocation,
  },
  {
    key: 'requested_arrival_time' as const,
    label: ICS215_COLUMN_LABELS.requestedArrivalTime,
  },
  { key: 'status' as const, label: ICS215_COLUMN_LABELS.status },
] as const;

export const ICS215_TABLE_MIN_WIDTH_PX = 1100;
